import React, { FC } from 'react';
import styles from './styles.module.css';
import { Button } from '@clearcover/atlas';
import { reportEvent } from 'Shared/analytics';

interface RewardsPortalErrorChildren {
  rewardsRefresh: () => void;
}

export const RewardsPortalError: FC<RewardsPortalErrorChildren> = ({
  rewardsRefresh,
}) => {
  const handleClick = () => {
    rewardsRefresh();
  };

  reportEvent('rewards-center-error-screen:display');

  return (
    <div className={styles.container}>
      <h1>We experienced an error</h1>
      <p className={styles.errorText}>
        Your points are secure, but we ran into an issue while connecting to our
        reward system. Please try again later. If the issue persists, please
        reach out to our support team for further assistance.
      </p>
      <Button
        className={styles.button}
        variant="secondary"
        onClick={handleClick}
      >
        Refresh Page
      </Button>
    </div>
  );
};
